import React from "react";
import { connect } from "react-redux";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

class FilterPane extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }

        this.handleSelect = this.handleSelect.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const props = this.props;
        const { orderList } = nextProps;

        if (this.state.isOpen && props.orderList.isFetching === true && orderList.isFetching === false) {
            this.setState({ isOpen: false })
        }
    }

    handleSelect(e) {
        this.props.handleChangeAddressText(e)

        geocodeByAddress(e)
            .then(results =>
                getLatLng(results[0])
            )
            .then(latLng =>
                this.props.handleChangeAddress(latLng)
            )
            .catch(error => console.error('Error', error))
    }

    handleSwitch(e) {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    handleFilter(e) {
        e.preventDefault();

        this.props.handleSubmit();
        this.setState({ isOpen: false })
    }

    calculateDesc() {
        const {
            currentFilterValues,
            orderMethodType
        } = this.props;

        const sortByDict = {
            '-created_at': 'по времени',
            'location': 'по месту',
            '-price': 'по цене',
            '-cached_likes_count': 'по популярности',
            '-cached_duplicate_count': 'по повторному использованию',
        };

        let searchText = '';
        let searchArray = [];
        let sortText = '';
        let sortArray = [];

        if(currentFilterValues.q && currentFilterValues.q !== '') {
            searchArray.push(`по названию/номеру ${currentFilterValues.q}`);
        }
        if(currentFilterValues.address && (!currentFilterValues.radius || Number(currentFilterValues.radius) <= 0)) {
            searchArray.push(`по адресу ${currentFilterValues.address}`);
        }
        else if(Number(currentFilterValues.radius) > 0) {
            let placeText = currentFilterValues.address || 'Текущее местоположение';
            searchArray.push(`по адресу ${placeText} (${currentFilterValues.radius} км)`)
        }

        if(searchArray.length) searchText = ('Поиск' + searchArray.join(", ") + ". ");

        if(currentFilterValues.order_date_at) {
            sortArray.push(`Начало заказа ${currentFilterValues.order_date_at}`);
        }
         
        if(currentFilterValues.orderposition__order_method_type_id) {
            let res = orderMethodType.results.filter((item) => {
                return Number(item.id) === Number(currentFilterValues.orderposition__order_method_type_id);
            });

            if(res.length) sortArray.push(res[0].title);
        }

        if(currentFilterValues.order_by) {
            sortArray.push(`Сортировка ${sortByDict[currentFilterValues.order_by]}`);
        }

        if(sortArray.length) sortText = sortArray.join(", ") + ".";

        return `${searchText}${sortText}`
    }

    render() {
        const {
            handleOnChange,
            orderMethodType,
            filterValues,
            handleChangeDate,
            resetFilters,
            handleChangeAddressText
        } = this.props;

        const inputProps = {
            placeholder: 'Текущее местоположение',
            value: filterValues.address,
            onChange: (address) => handleChangeAddressText(address)
        }
        
        const { isFetching } = this.props.orderList;

        return (
            <div className="air-block rounded-white-block screen-bottom-block">
                <div className={this.state.isOpen ? "toggle-block-with-header maximized" : "toggle-block-with-header minimized"}>
                    <div onClick={this.handleSwitch.bind(this)} className="toggle-block-top white-block-top filter-main">
                        <div className="toggle-block-header">
                            <div>Фильтр</div>
                            <div className="toggle-block-header-hint">
                                {this.calculateDesc()}
                            </div>
                        </div>
                        <div className="toggle-block-icon"></div>
                    </div>
                    <div className="toggle-block-content white-block-content">

                        <form className="main-filter-form color-black-form">

                            <div style={{
                                marginBottom: "20px",
                                width: "100%",
                                fontWeight: "bold",
                                color: "#333",
                            }}>поиск</div>

                            <input
                                value={filterValues.q}
                                ref="name"
                                onChange={(e) => handleOnChange('q', e.target.value)}
                                placeholder="По номеру или названию заказа"
                                className="form-input-el"
                                style={{width: '100%'}}
                            />

                            <div className="place-container">
                                <PlacesAutocomplete
                                    inputProps={inputProps}
                                    onSelect={this.handleSelect} />
                            </div>

                            <select
                                value={filterValues.radius || ''}
                                onChange={(e) => handleOnChange('radius', e.target.value)}
                                ref="radius"
                                className="form-select"
                                name="projecttype">
                                <option value="-1" className="hidden">Радиус поиска</option>
                                <option value="1">1 км</option>
                                <option value="3">3 км</option>
                                <option value="5">5 км</option>
                                <option value="10">10 км</option>
                                <option value="0">Любое</option>
                            </select>

                            <div className="day-picker-input">
                                <DayPickerInput
                                    format="DD.MM.YYYY"
                                    value={filterValues.order_date_at}
                                    ref={el => (this.order_date_at = el)}
                                    onDayChange={
                                        (day) => handleChangeDate(day ? moment(day).format('DD.MM.YYYY') : '')
                                    }
                                    placeholder="DD/MM/YYYY"
                                />
                            </div>

                            <select
                                value={filterValues.orderposition__order_method_type_id || ''}
                                onChange={(e) => handleOnChange('orderposition__order_method_type_id', e.target.value)}
                                ref="order_method_type_id"
                                className="form-select"
                                name="sort">
                                <option value="0">Выберите метод</option>
                                {
                                    orderMethodType.results.map((item, index) => {
                                        return <option key={index} value={item.id}>{item.title}</option>
                                    })
                                }
                            </select>

                            <div style={{
                                marginBottom: "20px",
                                width: "100%",
                                fontWeight: "bold",
                                color: "#333",
                            }}>сортировка</div>

                            <select
                                value={filterValues.order_by || ''}
                                onChange={(e) => handleOnChange('order_by', e.target.value)}
                                ref="sort"
                                className="form-select"
                                name="sorting">
                                <option value="-created_at">По времени</option>
                                <option value="location">По месту</option>
                                <option value="-price">По цене</option>
                                <option value="-cached_likes_count">По популярности</option>
                                <option value="-cached_duplicate_count">По повторному использованию</option>
                            </select>

                            <div style={{
                                width:'100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '10px',
                                }}>
                                <a href="" onClick={resetFilters} className="main-filter-form-reset">Сбросить фильтр</a>

                                <div className="big-button button-action">
                                    <button
                                        type="submit"
                                        onClick={(e) => this.handleFilter(e)}
                                        className={isFetching ? 'disabled' : ''}>
                                        Применить
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(FilterPane);



// WEBPACK FOOTER //
// ./src/components/Orders/FilterPane.js